// extracted by mini-css-extract-plugin
export default {"search":"P6OB2u","largeSearch":"BXX6S7","focused":"xvaGDb","sticky":"wGs5qz","searchFadeIn":"I4BEW7","searchIcon":"f2GpKF"};